module.exports = "<p>\n  pricing works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pricing-booking/pricing/pricing.component.html
// module id = ./src/app/component/pricing-booking/pricing/pricing.component.html
// module chunks = main